import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {initializeApp, provideFirebaseApp, getApp} from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { UserAuthModalModule } from './components/user-auth-modal/user-auth-modal.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { LoadingModule } from './components/dialogs/loading/loading.component.module';
import { SelectProfileIconModule } from './components/dialogs/select-profile-icon/select-profile-icon.component.module';
import { UserNavSettingsModule } from './components/user-nav-settings/user-nav-settings.component.module';
import { environment } from 'src/environments/environment';
import { UserSettingsModule } from './components/dialogs/user-settings/user-settings.component.module';
import { CreateLabModule } from './components/create-lab/create-lab.component.module';
import { CreateGadgetModule } from './components/create-gadget/create-gadget.component.module';
import { CreateGadgetComponentModule } from './components/create-gadget-component/create-gadget-component.component.module';
import { NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatNativeDateModule } from '@angular/material/core';
import { DialogAlertConfirmModule } from './components/dialogs/dialog-alert-confirm/dialog-alert-confirm-component.module';
import { QuickJoinLabModule } from './components/quick-join-lab/quick-join-lab.component.module';
import { CloneLabModule } from './components/clone-lab/clone-lab.component.module';
import { NewLabModule } from './components/new-lab/new-lab.module';
import { CreateLabControllerDialogModule } from './components/create-lab-controller-dialog/create-lab-controller-dialog.component.module';
import { TutorialPanelModule } from './components/tutorial-panel/tutorial-panel.module';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule, IonicModule.forRoot(), AppRoutingModule,
    // Initialize AngularFire compat module FIRST (it creates the default app)
    AngularFireModule.initializeApp(environment.firebase),
    // Then use modular SDK which will use the existing default app
    provideFirebaseApp(() => {
      // Check if app already exists (from AngularFireModule)
      try {
        return getApp();
      } catch {
        // If no app exists, initialize it
        return initializeApp(environment.firebase);
      }
    }),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    UserAuthModalModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    LoadingModule,
    SelectProfileIconModule,
    UserNavSettingsModule,
    UserSettingsModule,
    CreateGadgetModule,
    CreateGadgetComponentModule,
    NgxMatNativeDateModule,
    MatNativeDateModule,
    DialogAlertConfirmModule,
    NewLabModule,
    CreateLabControllerDialogModule,
    TutorialPanelModule,
  ],
  
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },Storage],
  bootstrap: [AppComponent],
})
export class AppModule {}


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/languages/', '.json');
}